import { useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { ContactDetailsPurchaseOrdersPageDocument } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import PurchaseOrdersDataTable from 'modules/procurement/components/purchaseOrders/PurchaseOrdersDataTable'

const ContactsDetailsPurchaseOrdersPage: React.FC = () => {
  useEffect(() => {
    track(trackingEvents.accounting.viewContactDetailsPage, {
      view: 'pruchase_orders',
    })
  }, [])

  const { contactId } = useParams()

  const { data, loading, error } = useQuery(ContactDetailsPurchaseOrdersPageDocument, {
    variables: {
      id: String(contactId),
    },
  })
  const contact = data?.finance?.contact
  const canSeeContacts = data?.finance._policies.contactsSee.can ?? false
  const canSeePurchaseOrders = data?.procurement._policies.purchaseOrderRead.can ?? false

  return (
    <ResponsivePage.Body
      authorized={canSeeContacts && canSeePurchaseOrders}
      error={error}
      loading={loading}
      variant="full"
    >
      <Box paddingTop="s24">
        <PurchaseOrdersDataTable
          vendor={contact || undefined}
          currentTab="all"
          onTabChange={() => {}}
        />
      </Box>
    </ResponsivePage.Body>
  )
}

export default ContactsDetailsPurchaseOrdersPage
